export default __webpack_public_path__ + "assets/videos/loyalty-info-video.mov";